import request from '@/utils/request'

export function fetchList(query) {
    return request({
        url: '/admin/jobLevel/list',
        method: 'get',
        params: query
    })
}

export function batchSave(data) {
    return request({
        url: '/admin/jobLevel/batchSave',
        method: 'post',
        data
    })
}

export function batchUpdate(data) {
    return request({
        url: '/admin/jobLevel/batchUpdate',
        method: 'post',
        data
    })
}
